import { useEffect, useMemo, useState } from 'react'
import './style.css'
import { ReactComponent as CloseIcon } from "../../../Assets/icon/close.svg";
import { useNavigate } from 'react-router-dom';
import { endSession, fetchHistory } from '../../../Services/coaching';
import { VoiceHistoryItem } from '../../RelationShip/VoiceChatHistory';

const History = ({ onClose, sessionID, client, wavRecorder }) => {
  const navigate = useNavigate();
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetchHistory()
      .then((res) => {
        if (!mounted) return;
        // Align with Relationship VoiceChatHistory: use meeting_notes grouping
        // Some environments return grouping directly under payload
        let grouped = res?.payload?.meeting_notes || res?.meeting_notes || {};
        if (!Object.keys(grouped || {}).length && res?.payload && typeof res.payload === 'object') {
          const maybe = res.payload;
          const hasDurationKeys = ["Today","Yesterday","Previous 7 days","Previous 30 days","This year"].some(k => Array.isArray(maybe[k]));
          if (hasDurationKeys) grouped = maybe;
        }
        setGroupedData(grouped);
      })
      .catch((e) => setError(e?.message || 'Failed to load'))
      .finally(() => setLoading(false));
    return () => { mounted = false; };
  }, []);

  // search client-side by title/topic/description
  const filteredData = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return groupedData;
    const out = {};
    Object.entries(groupedData || {}).forEach(([k, arr]) => {
      out[k] = (arr || []).filter((it) => {
        const t = (it?.topic || it?.title || "").toLowerCase();
        const d = (it?.description || "").toLowerCase();
        return t.includes(q) || d.includes(q);
      });
    });
    return out;
  }, [groupedData, search]);

  // Flatten, sort desc by timestamp and take top 5
  const topFiveItems = useMemo(() => {
    const all = [];
    Object.values(filteredData || {}).forEach((arr) => {
      (arr || []).forEach((it) => all.push(it));
    });
    const sorted = all.sort((a, b) => {
      const ta = new Date(a?.timestamp || a?.created_at || a?.date || 0).getTime();
      const tb = new Date(b?.timestamp || b?.created_at || b?.date || 0).getTime();
      return tb - ta;
    });
    return sorted.slice(0, 5);
  }, [filteredData]);

  const handleNavigate = async () => {
    setNavigating(true);
    try {
      await client.disconnect();
      await wavRecorder.end();
      await endSession(sessionID, false);
    } catch (error) {
      console.error(error);
    } finally {
      setNavigating(false);
      navigate('/myprofile');
    }
  };

  return (
    <div className="coaching-history-container">
      <div className="coaching-history-header">
        <div></div>
        <CloseIcon style={{ cursor: 'pointer' }} onClick={onClose} />
      </div>
      <div className="coaching-history-main-section">
        <p className='coaching-history-main-section-title'>Aris Dialogues history</p>
        <div className="chat-history-search" style={{ margin: '0 16px 12px' }}>
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="chat-history-search-input"
          />
        </div>
        <div className="chat-history-list-cntr">
          {loading && <div className="chat-history-loading">Loading...</div>}
          {error && <div className="chat-history-error">{String(error)}</div>}
          {!loading && !error && (
            <>
              {topFiveItems.length === 0 && (
                <div className="chat-history-empty" style={{ padding: "16px", color: "#7E7F83" }}>
                  No voice dialogues present. Please start voice dialogue to see your session summary.
                </div>
              )}
              {topFiveItems.map((item, idx) => (
                <VoiceHistoryItem
                  key={`${item.coaching_id || item.timestamp || idx}`}
                  item={item}
                  onClick={() => { window.location.href = "/coachingHistory"; }}
                />
              ))}
            </>
          )}
        </div>
      </div>
      <div className="coaching-history-footer">
        <div
          className={`open-your-profile-button-container ${navigating && 'navigate'}`}
          onClick={() => {
            if (!navigating) {
              handleNavigate();
            }
          }}
        >
          {navigating ? 'Navigating' : 'Open in your profile'}
        </div>
      </div>
    </div>
  );
};

export default History;